import { render, staticRenderFns } from "./TopSonResultsCard.vue?vue&type=template&id=0bcfe706"
import script from "./TopSonResultsCard.vue?vue&type=script&lang=js"
export * from "./TopSonResultsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports